/// FOURJS_START_COPYRIGHT(D,2015)
/// Property of Four Js*
/// (c) Copyright Four Js 2015, 2026. All Rights Reserved.
/// * Trademark of Four Js Development Tools Europe Ltd
///   in the United States and elsewhere
///
/// This file can be modified by licensees according to the
/// product manual.
/// FOURJS_END_COPYRIGHT

"use strict";

modulum("MonitorDebugTreeItemWidget", ["WidgetGroupBase", "WidgetFactory"], function (context, cls) {
  /**
   * @class MonitorDebugTreeItemWidget
   * @memberOf classes
   * @extends classes.WidgetGroupBase
   */
  cls.MonitorDebugTreeItemWidget = context.oo.Class(cls.WidgetGroupBase, function ($super) {
    return /** @lends classes.MonitorDebugTreeItemWidget.prototype */ {
      __name: "MonitorDebugTreeItemWidget",
      _container: null,
      _label: null,
      _idRefElement: null,
      _idRef: null,
      _collapsed: false,

      /**
       * @inheritDoc
       */
      _initElement: function () {
        $super._initElement.call(this);
        this._container = cls.DOMElementHelper.child(this._element, "description");
        this._label = cls.DOMElementHelper.child(this._container, "label");
        this._idRefElement = cls.DOMElementHelper.child(this._container, "idRef");
        cls.DOMElementHelper.on(this._container, "click.MonitorDebugTreeItemWidget", this._onClick.bind(this));
        cls.DOMElementHelper.on(this._container, "dblclick.MonitorDebugTreeItemWidget", this._onDoubleClick.bind(this));
      },

      /**
       * @inheritDoc
       */
      _initContainerElement: function () {
        $super._initContainerElement.call(this);
        this._containerElement.id = this.getRootClassName() + "__children";
        this.setAriaAttribute("controls", this._containerElement.id);
      },

      /**
       * @inheritDoc
       */
      destroy: function () {
        cls.DOMElementHelper.off(this._container, "click.MonitorDebugTreeItemWidget");
        cls.DOMElementHelper.off(this._container, "dblclick.MonitorDebugTreeItemWidget");
        $super.destroy.call(this);
      },

      /**
       * @inheritDoc
       */
      _onClick: function (e) {
        this.emit(gbc.constants.widgetEvents.click);
        e.stopPropagation();
      },

      /**
       * @inheritDoc
       */
      _onDoubleClick: function (event) {
        this._toggleCollapsed();
        event.stopPropagation();
      },

      /**
       * Define the label of the item in the tree view
       * @param {string} label - text to display
       */
      setLabel: function (label) {
        this._label.textContent = label;
      },

      /**
       * Define the VM idRef of the item in the tree view
       * @param {string} idRef - idRef to set
       */
      setIdRef: function (idRef) {
        this._idRef = idRef;
        this._idRefElement.textContent = idRef;
      },

      /**
       * Get the VM idRef of the item
       * @return {null}
       */
      getIdRef: function () {
        return this._idRef;
      },

      /**
       * Define the color of the icon
       * @param {string} color - CSS compliant color
       */
      setIconColor: function (color) {
        this.setStyle(">.description>.icon", {
          "background-color": color
        });
      },

      /**
       * Expand / collapse a tree part
       * @param {boolean} collapsed - true if collapsed, false otherwise
       */
      setCollapsed: function (collapsed) {
        this._toggleCollapsed(Boolean(collapsed));
      },

      /**
       * Expand / collapse a tree part
       * @param {boolean} collapsed - true if collapsed, false otherwise
       * @private
       */
      _toggleCollapsed: function (collapsed) {
        if (collapsed === true) {
          if (!this._collapsed) {
            this._collapsed = true;
            this._containerElement.remove();
          }
        } else if (collapsed === false) {
          if (this._collapsed) {
            this._collapsed = false;
            this._element.appendChild(this._containerElement);
          }
        } else {
          this._collapsed = !this._collapsed;
          if (this._collapsed) {
            this._containerElement.remove();
          } else {
            this._element.appendChild(this._containerElement);
          }
        }
        this.toggleClass("collapsed", this._collapsed);
        this.setAriaAttribute("expanded", !this._collapsed);
        // _containerElement is detached from the DOM while collapsed; clear aria-controls
        // accordingly so the attribute never references a node that's not in the document
        this.setAriaAttribute("controls", this._collapsed ? null : this._containerElement.id);
      },

      /**
       * Set item as highlighted
       * @param {boolean} highlighted - true if highlighted, false otherwise
       */
      setHighlighted: function (highlighted) {
        this.toggleClass("highlighted", highlighted);
        this.setAriaAttribute("selected", String(highlighted));
        if (highlighted) {
          let p = this.getParentWidget();
          while (p instanceof cls.MonitorDebugTreeItemWidget) {
            p.setCollapsed(false);
            p = p.getParentWidget();
          }
        }
      },

      setFocused: function (focused) {
        this.toggleClass("vmFocusedNode", focused);
      }
    };
  });
  cls.WidgetFactory.registerBuilder("MonitorDebugTreeItem", cls.MonitorDebugTreeItemWidget);
});
